import React, { useEffect, useRef } from 'react'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Getapp = () => {
    const textRef = useRef(null);
    const paraRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: textRef.current,
                start: "top 90%", 
                toggleActions: "play none none none",
            },
        });

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);

    useEffect(() => {
        gsap.fromTo(
            paraRef.current,
            { opacity: 0, y: 50 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: paraRef.current,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
            }
        );
    }, []);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: buttonRef.current,
                start: "top 90%",
                toggleActions: "play none none none",
            },
        });

        gsap.set(buttonRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(buttonRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 0.5,
            ease: "power2.out",
        })
            .to(buttonRef.current, {
                rotateY: 360,
                duration: 0.8,
                ease: "power2.inOut",
            });
    }, []);
    return (
        <>
            <section className='getappmainprnt'>
                <div className="custom-container">
                    <div className="getappchldmain">
                        <div className="imgtoppostiongetapp">
                            <img className='img-fluid' src="\assets\Chatandpay\topleftgetapp.png" alt="" />
                        </div>
                        <p ref={paraRef}>
                            Be part of the revolution.
                        </p>
                        <h2 ref={textRef}>
                            Join us in redefining the digital experience.
                        </h2>
                       <ul  className='getappsocialicon' ref={buttonRef}>
                        <li>
                             <a href="https://twitter.com/tomipioneers" rel="me" target='_blank'><img src="\assets\Aboutus\TwitterX.svg" alt="TwitterXimg" /></a>
                        </li>
                        <li>
                             <a href="https://t.me/tomi_official_chat" rel="me" target='_blank'><img src="\assets\Aboutus\Telegram App.svg" alt="Telegramimg" /></a>
                        </li>
                        <li>
                             <a href="https://discord.com/invite/tomipioneers" rel="me" target='_blank'><img src="\assets\Aboutus\Discord New.svg" alt="Discordimg" /></a>
                        </li>
                        <li>
                             <a href="https://medium.com/tomipioneers" rel="me" target='_blank'><img src="\assets\Aboutus\Medium.svg" alt="Mediumimg" /></a>
                        </li>
                        <li>
                             <a href="https://www.youtube.com/@tomipioneers" rel="me" target='_blank'><img src="\assets\Aboutus\YouTube.svg" alt="YouTubeimg" /></a>
                        </li>
                       </ul>

                        <div className="imgbottompostiongetapp">
                            <img className='img-fluid' src="\assets\Storageimages\bottomrightgetapp.png" alt="img" />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Getapp